<template>
  <v-container fluid class="av-page">
    <!-- Filtros -->
    <div class="av-card av-filtro-card">
      <span class="av-section-label">Filtros</span>
      <v-row dense>
        <v-col cols="12" sm="6" md="3">
          <v-select
            outlined
            dense
            hide-details
            clearable
            v-model="filtros.modelo"
            :items="modelos"
            item-text="text"
            item-value="value"
            label="Registro/Tela"
            @change="aplicarFiltros()"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-select
            outlined
            dense
            hide-details
            clearable
            v-model="filtros.acao"
            :items="acoes"
            item-text="text"
            item-value="value"
            label="Ação"
            @change="aplicarFiltros()"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-autocomplete
            outlined
            dense
            hide-details
            clearable
            v-model="filtros.empresaId"
            :items="empresas"
            item-text="nome"
            item-value="id"
            label="Empresa"
            no-data-text="Nenhuma empresa encontrada"
            @change="aplicarFiltros()"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-menu
            v-model="menuDataInicial"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="formatarDataBr(filtros.dataInicial)"
                label="De"
                outlined
                dense
                hide-details
                readonly
                clearable
                prepend-inner-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
                @click:clear="limparData('dataInicial')"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filtros.dataInicial"
              locale="pt-br"
              no-title
              scrollable
              @input="menuDataInicial = false; aplicarFiltros()"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-menu
            v-model="menuDataFinal"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="formatarDataBr(filtros.dataFinal)"
                label="Até"
                outlined
                dense
                hide-details
                readonly
                clearable
                prepend-inner-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
                @click:clear="limparData('dataFinal')"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filtros.dataFinal"
              locale="pt-br"
              no-title
              scrollable
              @input="menuDataFinal = false; aplicarFiltros()"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </div>

    <div class="av-card av-panel">
      <div class="av-toolbar">
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" @click="carregaLogs()">
          <v-icon left>refresh</v-icon>Atualizar
        </v-btn>
      </div>

      <v-data-table
        :headers="tabela.cabecalho"
        :items="tabela.conteudo"
        :options.sync="opcoes"
        :server-items-length="totalRegistros"
        :loading="tabela.carregamento"
        loading-text="Buscando registros..."
        class="av-table"
        :footer-props="{
          'items-per-page-text': 'Linhas por página',
          'items-per-page-options': [10, 20, 50, 100],
        }"
      >
        <template v-slot:[`item.created`]="{ item }">
          {{ formatarData(item.created) }}
        </template>

        <template v-slot:[`item.modelo`]="{ item }">
          {{ rotuloModelo(item.modelo) }}
        </template>

        <template v-slot:[`item.acao`]="{ item }">
          <v-chip small label dark :color="corAcao(item.acao)">{{ rotuloAcao(item.acao) }}</v-chip>
        </template>

        <template v-slot:[`item.usuarioNome`]="{ item }">
          <span v-if="item.usuarioNome">{{ item.usuarioNome }}</span>
          <span v-else class="av-sistema">— sistema —</span>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small v-on="on" @click="verDetalhes(item)">
                <v-icon small color="primary">mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>Ver detalhes</span>
          </v-tooltip>
        </template>

        <template v-slot:no-data>
          <v-alert dense text outlined type="info" class="my-4">
            Nenhum registro de auditoria encontrado.
          </v-alert>
        </template>
      </v-data-table>
    </div>

    <!-- Detalhes -->
    <v-dialog v-model="dialogoDetalhes" max-width="700px" scrollable>
      <v-card v-if="detalhe">
        <v-card-title class="av-dialog-title">
          <v-chip small label dark :color="corAcao(detalhe.acao)" class="mr-2">{{ rotuloAcao(detalhe.acao) }}</v-chip>
          {{ rotuloModelo(detalhe.modelo) }}
          <v-spacer></v-spacer>
          <span class="av-dialog-data">{{ formatarData(detalhe.created) }}</span>
        </v-card-title>
        <p class="av-dialog-hint">
          Autor: {{ detalhe.usuarioNome || '— sistema —' }}
          <span v-if="detalhe.usuarioEmail">({{ detalhe.usuarioEmail }})</span>
          <span v-if="detalhe.ip"> • IP: {{ detalhe.ip }}</span>
        </p>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <div v-if="detalhe.acao === 'UPDATE' && detalhe.alteracoes">
            <span class="av-section-label">Campos alterados</span>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Campo</th>
                    <th>De</th>
                    <th>Para</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(valor, campo) in detalhe.alteracoes" :key="campo">
                    <td class="font-weight-medium">{{ campo }}</td>
                    <td><pre class="valorJson">{{ formatarValor(valor.de) }}</pre></td>
                    <td><pre class="valorJson">{{ formatarValor(valor.para) }}</pre></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>

          <div v-if="detalhe.dados">
            <span class="av-section-label mt-3">
              {{ detalhe.acao === 'DELETE' ? 'Registro excluído' : 'Snapshot do registro' }}
            </span>
            <pre class="valorJson bloco">{{ formatarValor(detalhe.dados) }}</pre>
          </div>

          <div v-if="!detalhe.alteracoes && !detalhe.dados" class="av-page-subtitle">
            Sem detalhes adicionais para este registro.
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoDetalhes = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Snackbar ref="chamaSnackbar" />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import moment from 'moment'

  export default {
    name: 'Auditoria',
    components: { Snackbar },
    data: () => ({
      empresas: [],
      modelos: [
        { text: 'Empresa', value: 'Empresa' },
        { text: 'Usuário', value: 'Usuario' },
        { text: 'Pesquisa', value: 'Questionario' },
        { text: 'Pergunta', value: 'Perguntas' },
        { text: 'Dispositivo', value: 'Dispositivo' },
      ],
      acoes: [
        { text: 'Criação', value: 'CREATE' },
        { text: 'Alteração', value: 'UPDATE' },
        { text: 'Exclusão', value: 'DELETE' },
      ],
      filtros: {
        modelo: null,
        acao: null,
        empresaId: null,
        dataInicial: moment().format('YYYY-MM-DD'),
        dataFinal: moment().format('YYYY-MM-DD'),
      },
      menuDataInicial: false,
      menuDataFinal: false,
      opcoes: {
        page: 1,
        itemsPerPage: 20,
      },
      totalRegistros: 0,
      tabela: {
        cabecalho: [
          { text: 'Data/Hora', value: 'created' },
          { text: 'Registro/Tela', value: 'modelo' },
          { text: 'Ação', value: 'acao' },
          { text: 'Autor', value: 'usuarioNome' },
          { text: 'IP', value: 'ip' },
          { text: 'Detalhes', value: 'action', sortable: false, align: 'center' },
        ],
        carregamento: false,
        conteudo: [],
      },
      dialogoDetalhes: false,
      detalhe: null,
    }),

    watch: {
      opcoes: {
        handler() {
          this.carregaLogs()
        },
        deep: true,
      },
    },

    mounted() {
      this.carregaEmpresas()
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC","fields":{"nome":true,"id":true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data && response.data.length > 0) {
            this.empresas = response.data
          }
        })
        .catch(() => {})
      },

      aplicarFiltros() {
        if (this.opcoes.page !== 1) {
          this.opcoes.page = 1 // o watch dispara o carregaLogs
        } else {
          this.carregaLogs()
        }
      },

      async carregaLogs() {
        this.tabela.carregamento = true
        var vm = this
        const params = {
          pagina: this.opcoes.page,
          porPagina: this.opcoes.itemsPerPage,
          access_token: sessionStorage.getItem('accToken'),
        }
        if (this.filtros.modelo) params.modelo = this.filtros.modelo
        if (this.filtros.acao) params.acao = this.filtros.acao
        if (this.filtros.empresaId) params.empresaId = this.filtros.empresaId
        if (this.filtros.dataInicial) params.dataInicial = moment(this.filtros.dataInicial, 'YYYY-MM-DD').startOf('day').toISOString()
        if (this.filtros.dataFinal) params.dataFinal = moment(this.filtros.dataFinal, 'YYYY-MM-DD').endOf('day').toISOString()

        await axios.get(baseApiUrl + 'LogsAuditoria/consultar', { params })
        .then(response => {
          this.tabela.conteudo = (response.data && response.data.dados) || []
          this.totalRegistros = (response.data && response.data.total) || 0
        })
        .catch(() => {
          this.tabela.conteudo = []
          this.totalRegistros = 0
          vm.$refs.chamaSnackbar.snack('#FEC8C8', 'Erro ao consultar a auditoria.', '#BF4554')
        })
        this.tabela.carregamento = false
      },

      verDetalhes(item) {
        this.detalhe = item
        this.dialogoDetalhes = true
      },

      formatarData(data) {
        return data ? moment(data).format('DD/MM/YYYY HH:mm:ss') : ''
      },

      formatarDataBr(data) {
        return data ? moment(data, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
      },

      limparData(campo) {
        this.filtros[campo] = null
        this.aplicarFiltros()
      },

      formatarValor(valor) {
        if (valor === null || valor === undefined) return '—'
        if (typeof valor === 'object') return JSON.stringify(valor, null, 2)
        return String(valor)
      },

      rotuloModelo(modelo) {
        const m = this.modelos.find(x => x.value === modelo)
        return m ? m.text : modelo
      },

      rotuloAcao(acao) {
        const a = this.acoes.find(x => x.value === acao)
        return a ? a.text : acao
      },

      corAcao(acao) {
        if (acao === 'CREATE') return '#43A047'
        if (acao === 'UPDATE') return '#FB8C00'
        if (acao === 'DELETE') return '#E53935'
        return '#757575'
      },
    },
  }
</script>

<style scoped>
  .av-page {
    padding: 20px 24px;
  }

  .av-filtro-card {
    padding: 16px;
    margin-bottom: 16px;
  }

  .av-panel {
    padding: 16px 16px 8px;
  }

  .av-section-label {
    display: block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .4px;
    text-transform: uppercase;
    color: var(--av-text-soft);
    margin-bottom: 8px;
  }

  .av-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
    flex-wrap: wrap;
  }

  @media (max-width: 599px) {
    .av-toolbar {
      flex-direction: column;
      align-items: stretch;
    }

    .av-toolbar .v-spacer {
      display: none;
    }

    .av-toolbar .v-btn {
      width: 100%;
    }
  }

  .av-dialog-title {
    font-size: 17px;
    font-weight: 600;
    color: var(--av-text);
    padding-bottom: 2px;
  }

  .av-dialog-data {
    font-size: 13px;
    font-weight: 400;
    color: var(--av-text-soft);
  }

  .av-dialog-hint {
    margin: 0;
    padding: 0 16px 12px;
    font-size: 13px;
    color: var(--av-text-soft);
  }

  .av-sistema {
    color: var(--av-text-soft);
    font-style: italic;
  }

  .valorJson {
    font-family: 'Courier New', monospace;
    font-size: 12px;
    white-space: pre-wrap;
    word-break: break-word;
    margin: 0;
  }

  .valorJson.bloco {
    background: #f5f7fa;
    border: 1px solid var(--av-border);
    padding: 10px;
    max-height: 320px;
    overflow: auto;
  }

  /* Respiro confortável entre os filtros */
  ::v-deep .av-filtro-card .row > [class*="col"] {
    padding-top: 6px;
    padding-bottom: 6px;
  }

  /* Cabeçalho legível, sobrepondo o CSS global herdado das telas legadas */
  ::v-deep .av-table .v-data-table__wrapper > table > thead > tr > th {
    color: var(--av-text-soft) !important;
    background: #f7f9f9;
    font-size: 12.5px;
    font-weight: 600;
    white-space: nowrap;
    border-bottom: 1px solid var(--av-border) !important;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > thead > tr > th,
  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr > td {
    height: 46px;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr > td {
    border-bottom: 1px solid #eef1f1 !important;
    font-size: 13.5px;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr:hover {
    background: #f5f8f8;
  }

  ::v-deep .av-table.v-data-table {
    background: transparent;
  }
</style>
